import { API_URL } from './config';

export async function getCredentialManagement(authToken) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/credential`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching template.');
  }
  return await res.json();
}

export async function getCredentialManagementLocation(
  authToken,
  location,
  organization
) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/credential/${location}/${organization}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching template.');
  }
  return await res.json();
}

export async function getCredentialManagementLocationRemainder(
  authToken,
  location,
  organization
) {
  if (!authToken) {
    return;
  }

  const res = await fetch(
    `${API_URL}/credential/remainder/alert/${location}/${organization}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    }
  );
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching template.');
  }
  return await res.json();
}

export async function getCredentialManagementRemainder(authToken) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/credential/remainder`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching template.');
  }
  return await res.json();
}
